import { TASK_MANAGER_STATUS } from "@/config/const";

export default {

  localProgressTaskCount: state => {
    return state.localTasks.filter(item => item.status === TASK_MANAGER_STATUS.PROGRESS).length;
  },

  displayLocalTask: (_, getters) => {

    //ローカルタスク件数が表示開始位置より少ない場合はから配列を返す
    if(getters.startTaskNum > getters.filteredLocalTasks.length) return [];

    return getters.filteredLocalTasks.slice((getters.startTaskNum - 1), getters.endTaskNum);
  },

  filteredLocalTasks: (state) => {

    const filterItems = state.localTasks.filter(item => {
      //名前でフィルター
      if (state.filterName && state.filterName.length > 0 && !item.name.includes(state.filterName)) return false;

      //種別でフィルター
      if (state.selectedFilterCategory && state.selectedFilterCategory !== item.type) return false;

      //進捗状況でフィルター
      if (state.selectedFilterStatus && state.selectedFilterStatus !== item.status) return false;

      return true;
    })

    return filterItems
  },

  filteredLocalTasksCount: (_, getters) => {
    return getters.filteredLocalTasks.length;
  },

  displayLocalTaskCount: (_, getters) => {
    return getters.displayLocalTask.length;
  },

  startTaskNum: state => {
    return state.taskPageSize * (state.currentTaskPage - 1) + 1
  },

  endTaskNum: state => {
    const pageEndNum = state.taskPageSize * state.currentTaskPage;
    return Math.min(state.totalTaskCount, pageEndNum)
  },

  requestTaskOffset: (_, getters) => {
    return getters.displayLocalTaskCount;
  },

  requestTaskSize: (state, getters) => {
    return state.taskPageSize - getters.displayLocalTaskCount;
  },

  requestPage: (state, getters) => {
    if(getters.filteredLocalTasksCount === 0) return state.currentTaskPage - 1;

    const totalLocalTaskPgae = Math.ceil(getters.filteredLocalTasksCount / state.taskPageSize);

    return Math.max(state.currentTaskPage - totalLocalTaskPgae -1, 0);

  },
};
